import { act } from "react";
import { ICongThucTinhDiemSubActionTypes } from "../../action-types/category/ICongThucTinhDiemSubActions";
import { ICongThucTinhDiemSubReducer } from "../../reducer-model/category/ICongThucTinhDiemSubReduce";
import { IThanhPhanMon } from "../../../model/response/category/IThanhPhanMon";
import { ICongThucTinhDiemSub } from "../../../model/response/category/ICongThucTinhDiemSub";
import { IThanhPhanThi } from "../../../model/response/category/IThanhPhanThi";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState : ICongThucTinhDiemSubReducer = {
    congThucs: [],
}

export const congThucTinhDiemSubReducer = (
    state = iniState,
    action: ICongThucTinhDiemSubActionTypes
): ICongThucTinhDiemSubReducer => {
    switch (action.type) {
        case "CONG_THUC_TINH_DIEM_SUB_INI_START":
            return {
                ...state, 
                congThucs: [
                    ...state.congThucs, {
                    id_cong_thuc: action.payload,
                    congThucTinhDiemSubs: [],
                    status: eReducerStatusBase.is_not_initialization,
                }]
            };
        case "CONG_THUC_TINH_DIEM_SUB_LOAD_BY_CONG_THUC_START":
            return {
                ...state,
                congThucs: state.congThucs.map(x => {
                    if (x.id_cong_thuc === action.payload){
                        return {
                            ...x,
                            status: eReducerStatusBase.is_loading,
                        }
                    }
                    return x;
                })
            };
        case "CONG_THUC_TINH_DIEM_SUB_LOAD_BY_CONG_THUC_SUCCESS":
            return {
                ...state,
                congThucs: state.congThucs.map(ct => {
                    if (ct.id_cong_thuc === action.payload.id_cong_thuc){
                        const data = Array.isArray(action.payload.data) ? action.payload.data : [];
                        return {
                            ...ct,
                            id_cong_thuc: action.payload.id_cong_thuc,
                            status: eReducerStatusBase.is_completed,
                            congThucTinhDiemSubs: data,
                            thanPhanMonSelectedIds: data.filter(x => x.id_thanh_phan > 0).map(x => x.id_thanh_phan),
                            thanPhanThiSelectedIds: data.filter(x => x.id_thanh_phan_thi > 0).map(x => x.id_thanh_phan_thi),
                        }
                    }
                    return ct;
                })
                
            };
        case "CONG_THUC_TINH_DIEM_SUB_LOAD_BY_CONG_THUC_ERROR":
            return {
                ...state,
               congThucs: state.congThucs.map(x => {
                    if (x.id_cong_thuc === action.payload.id_cong_thuc) {
                        return {
                            ...x,
                            status: eReducerStatusBase.is_completed,
                        };
                    }
                    return x;
                })
            };

        case "CONG_THUC_TINH_DIEM_SUB_CHANGE_THANH_PHAN_MON":
            return {
                ...state,
                congThucs: state.congThucs.map(x => {
                    if (x.id_cong_thuc === action.payload.id_cong_thuc) {
                        const updatedSubs = x.congThucTinhDiemSubs.map(sub => {
                            if (sub.id_thanh_phan === action.payload.id_thanh_phan) {
                                return {
                                    ...sub,
                                    ty_le: action.payload.ty_le,
                                    ty_le_nhom: action.payload.ty_le_nhom,
                                    nhom: action.payload.nhom
                                };
                            }
                            return sub;
                        });
                        return {
                            ...x,
                            congThucTinhDiemSubs: updatedSubs,
                            status: eReducerStatusBase.is_completed
                        };
                    }
                    return x;
                })
            };
         case "CONG_THUC_TINH_DIEM_SUB_CHANGE_THANH_PHAN_THI":
            return {
                ...state,
                congThucs: state.congThucs.map(x => {
                    if (x.id_cong_thuc === action.payload.id_cong_thuc) {
                        const updatedSubs = x.congThucTinhDiemSubs.map(sub => {
                            if (sub.id_thanh_phan_thi === action.payload.id_thanh_phan_thi) {
                                return {
                                    ...sub,
                                    ty_le: action.payload.ty_le,
                                    ty_le_nhom: action.payload.ty_le_nhom,
                                    nhom: action.payload.nhom
                                };
                            }
                            return sub;
                        });
                        return {
                            ...x,
                            congThucTinhDiemSubs: updatedSubs,
                            status: eReducerStatusBase.is_completed
                        };
                    }
                    return x;
                })
            };
        
        case "CONG_THUC_TINH_DIEM_SUB_SAVE_START":
            return {
                ...state,
                congThucs: state.congThucs.map(x => {
                    if (x.id_cong_thuc === action.payload.id_cong_thuc) {
                        return {
                            ...x,
                            status: eReducerStatusBase.is_saving,
                        };
                    }
                    return x;
                })
            };
    
        case "CONG_THUC_TINH_DIEM_SUB_SAVE_SUCCESS":
             return {
                ...state,
                congThucs: state.congThucs.map(x => {
                    if (x.id_cong_thuc === action.payload.id_cong_thuc) {
                        return {
                            ...x,
                            status: eReducerStatusBase.is_need_reload,
                        };
                    }
                    return x;
                })
            };
        case "CONG_THUC_TINH_DIEM_SUB_SAVE_ERROR":
            return {
                ...state,
                 congThucs: state.congThucs.map(x => {
                    if (x.id_cong_thuc === action.payload.id_cong_thuc) {
                        return {
                            ...x,
                            status: eReducerStatusBase.is_completed,
                        };
                    }
                    return x;
                })
            };
      
        case "CONG_THUC_TINH_DIEM_SUB_CHANGE_SELECTED_IDS":
            return {          
                ...state,
                congThucs: state.congThucs.map(x => {
                    if (x.id_cong_thuc === action.payload.id_cong_thuc) {
                        let updatedSubs = [...x.congThucTinhDiemSubs];
                        const selectedIds = action.payload.listIds;
                        // 1. Thêm mới các id được chọn nhưng chưa có trong congThucTinhDiemSubs
                        selectedIds.forEach(id => {
                            if (!updatedSubs.some(sub => sub.id_thanh_phan === id)) {
                                const thanhPhanThis = action.payload.data as IThanhPhanMon[];
                                const thanhPhanMon = thanhPhanThis.find(tp => tp.id_thanh_phan === id);
                                if (thanhPhanMon) {
                                updatedSubs.push({
                                    id_thanh_phan: id,
                                    id_cong_thuc: x.id_cong_thuc,
                                    id_cong_thuc_sub: 0,
                                    ty_le: thanhPhanMon.ty_le,
                                    ty_le_nhom: thanhPhanMon.ty_le_nhom,
                                    nhom: thanhPhanMon.nhom,
                                    id_thanh_phan_thi: 0
                                });                             
                            }
                            }
                        });
                        // 2. Xử lý các item không được chọn
                        updatedSubs = updatedSubs
                            .map(sub => {
                                if (sub.id_thanh_phan > 0 && !selectedIds.includes(sub.id_thanh_phan)) {
                                    if (sub.id_cong_thuc_sub === 0) {
                                        // Xóa nếu id_cong_thuc_sub = 0
                                        return null;
                                    } else if (sub.id_cong_thuc_sub > 0) {
                                        // Chuyển thành âm nếu id_cong_thuc_sub > 0
                                        return { ...sub, id_cong_thuc_sub: -Math.abs(sub.id_cong_thuc_sub) };
                                    }
                                } else if (sub.id_cong_thuc_sub < 0) {
                                    // Chọn lại thì chuyển về dương
                                    return { ...sub, id_cong_thuc_sub: Math.abs(sub.id_cong_thuc_sub) };
                                }
                                return sub;
                            })
                            .filter((sub): sub is ICongThucTinhDiemSub => sub !== null);
                        return {
                            ...x,
                            congThucTinhDiemSubs: updatedSubs,
                            thanPhanMonSelectedIds: selectedIds ,
                        };
                    }
                    return x;
                }),
                
            };
        case "CONG_THUC_TINH_DIEM_SUB_CHANGE_SELECTED_THANH_PHAN_THI_IDS":
            return {          
                ...state,
                congThucs: state.congThucs.map(x => {
                    if (x.id_cong_thuc === action.payload.id_cong_thuc) {
                        let updatedSubs = [...x.congThucTinhDiemSubs];
                        const selectedIds = action.payload.listIds;
                        // 1. Thêm mới các id được chọn nhưng chưa có trong congThucTinhDiemSubs
                        selectedIds.forEach(id => {
                            if (!updatedSubs.some(sub => sub.id_thanh_phan_thi === id)) {
                                const thanhPhanThis = action.payload.data as IThanhPhanThi[];
                                const thanhPhanThi = thanhPhanThis.find(tp => tp.id_thanh_phan_thi === id);
                                if (thanhPhanThi) {
                                updatedSubs.push({
                                    id_thanh_phan: 0,
                                    id_cong_thuc: x.id_cong_thuc,
                                    id_cong_thuc_sub: 0,
                                    ty_le: thanhPhanThi.ty_le,
                                    ty_le_nhom: thanhPhanThi.ty_le_nhom,
                                    nhom: thanhPhanThi.nhom,
                                    id_thanh_phan_thi: id
                                });                             
                            }
                            }
                        });
                        // 2. Xử lý các item không được chọn
                        updatedSubs = updatedSubs
                            .map(sub => {
                                if (sub.id_thanh_phan_thi > 0 && !selectedIds.includes(sub.id_thanh_phan_thi)) {
                                    if (sub.id_cong_thuc_sub === 0) {
                                        // Xóa nếu id_cong_thuc_sub = 0
                                        return null;
                                    } else if (sub.id_cong_thuc_sub > 0) {
                                        // Chuyển thành âm nếu id_cong_thuc_sub > 0
                                        return { ...sub, id_cong_thuc_sub: -Math.abs(sub.id_cong_thuc_sub) };
                                    }
                                } else if (sub.id_cong_thuc_sub < 0) {
                                    // Chọn lại thì chuyển về dương
                                    return { ...sub, id_cong_thuc_sub: Math.abs(sub.id_cong_thuc_sub) };
                                }
                                return sub;
                            })
                            .filter((sub): sub is ICongThucTinhDiemSub => sub !== null);
                        return {
                            ...x,
                            congThucTinhDiemSubs: updatedSubs,
                            thanPhanThiSelectedIds: selectedIds ,
                        };
                    }
                    return x;
                }),
                
            };
        
        default:
            return state;
    }
}